export default [
  {
    _name: "CSidebarNav",

    _children: [
      {
        _name: "CSidebarNavItem",
        name: "Inicio",
        to: "/home",

        icon: "cil-home"
      },
      {
        _name: "CSidebarNavDropdown",
        name: "Indicadores",
        route: "/indicadores",
        icon: "cil-bar-chart",
        items: [
          {
            name: "Administrativos",
            to: "/indicadores/administrativos/ingresos",
            icon: "cil-puzzle"
          },
          {
            name: "Operativos",
            to: "/indicadores/operativos/produccion",
            icon: "cil-puzzle"
          },
          {
            name: "Analítica",
            to: "/indicadores/analytics",
            icon: "cil-puzzle",
            credential: "@view:schema=analytics\\|.*consultar"
          }
        ]
      },
      {
        _name: "CSidebarNavDropdown",
        name: "Reportes",
        route: "/reports",
        icon: "cil-clipboard",
        items: [
          {
            name: "Excel",
            to: "/reports",
            icon: "cil-puzzle"
          },
          {
            name: "PDF",
            to: "/reports/pdf",
            icon: "cil-puzzle"
          },
          {
            name: "Análisis",
            to: "/reports/analisis",
            icon: "cil-puzzle"
          }
        ]
      },
      // {
      //   _name: "CSidebarNavDropdown",
      //   name: "Planeación",
      //   to: "/planeacion",
      //   icon: "cil-industry",
      //   items: [
      //     {
      //       name: "Registrar lotes",
      //       to: "/planeacion/lotes",
      //       icon: "cil-puzzle"
      //     }
      //   ]
      // },
      {
        to: "/panel",
        _name: "CSidebarNavItem",
        name: "Inventario",
        icon: "cil-columns"
      },
      {
        _name: "CSidebarNavItem",
        name: "Operaciones",
        to: "/operaciones",
        icon: "cil-applications"
      },
      {
        to: "/correcciones",
        _name: "CSidebarNavItem",
        name: "Correcciones",
        icon: "cil-view-column"
      },
      // {
      //   _name: "CSidebarNavDropdown",
      //   name: "Consultas",
      //   route: "/consultas",
      //   icon: "cil-notes",
      //   items: [
      //     {
      //       name: "Costos",
      //       to: "/consultas/costos",
      //       icon: "cil-cursor"
      //     }
      //   ]
      // },

      {
        _name: "CSidebarNavDropdown",
        name: "Catálogos",
        route: "/catalogos",
        icon: "cil-book",
        _attrs: { placement: "top-start" },
        items: [
          {
            name: "Actividades",
            to: "/catalogos/actividades",
            icon: "cil-pencil",
            credential: "@catalogo:schema=actividades\\|.*consultar"
          },
          {
            name: "Almacenes",
            to: "/catalogos/almacenes",
            icon: "cil-pencil",
            credential: "@catalogo:schema=almacenes\\|.*consultar"
          },
          {
            name: "Clientes",
            to: "/catalogos/clientes",
            icon: "cil-pencil",
            credential: "@catalogo:schema=clientes\\|.*consultar"
          },
          {
            name: "Costos de Actividades",
            to: "/catalogos/actividades-costos",
            icon: "cil-pencil",
            credential: "@catalogo:schema=actividades_costos\\|.*consultar"
          },
          {
            name: "Cultivos",
            to: "/catalogos/cultivos",
            icon: "cil-pencil",
            credential: "@catalogo:schema=cultivos\\|.*consultar"
          },
          {
            name: "Dispositivos",
            to: "/catalogos/dispositivos",
            icon: "cil-pencil",
            credential: "@catalogo:schema=dispositivos\\|.*consultar"
          },
          {
            name: "Empaques",
            to: "/catalogos/empaques",
            icon: "cil-pencil",
            credential: "@catalogo:schema=empaques\\|.*consultar"
          },
          {
            name: "Empresas",
            to: "/catalogos/empresas",
            icon: "cil-pencil",
            credential: "@catalogo:schema=empresas\\|.*consultar"
          },
          {
            name: "Gastos",
            to: "/catalogos/servicios",
            icon: "cil-pencil",
            credential: "@catalogo:schema=servicios\\|.*consultar"
          },
          {
            name: "Operadores",
            to: "/catalogos/operadores",
            icon: "cil-pencil",
            credential: "@catalogo:schema=operadores\\|.*consultar"
          },
          {
            name: "Productos",
            to: "/catalogos/productos",
            icon: "cil-pencil",
            credential: "@catalogo:schema=productos\\|.*consultar"
          },
          {
            name: "Proveedores",
            to: "/catalogos/proveedores",
            icon: "cil-pencil",
            credential: "@catalogo:schema=proveedores\\|.*consultar"
          },
          {
            name: "Puestos",
            to: "/catalogos/puestos",
            icon: "cil-pencil",
            credential: "@catalogo:schema=puestos\\|.*consultar"
          },

          {
            name: "Trabajadores",
            to: "/catalogos/trabajadores",
            icon: "cil-pencil",
            credential: "@catalogo:schema=trabajadores\\|.*consultar"
          },
          {
            name: "Ubicaciones",
            to: "/catalogos/ubicaciones",
            icon: "cil-pencil",
            _credential: "@catalogo:schema=ubicaciones\\|.*consultar"
          }
        ]
      }
      // {
      //   _name: "CSidebarNavDropdown",
      //   name: "Notifications",
      //   route: "/notifications",
      //   icon: "cil-bell",
      //   items: [
      //     {
      //       name: "Alerts",
      //       to: "/notifications/alerts",
      //       icon: "cil-bell"
      //     },
      //     {
      //       name: "Badges",
      //       to: "/notifications/badges",
      //       icon: "cil-bell"
      //     },
      //     {
      //       name: "Modals",
      //       to: "/notifications/modals",
      //       icon: "cil-bell"
      //     }
      //   ]
      // },
      // {
      //   _name: "CSidebarNavItem",
      //   name: "Widgets",
      //   to: "/widgets",
      //   icon: "cil-calculator",
      //   badge: {
      //     color: "primary",
      //     text: "NEW",
      //     shape: "pill"
      //   }
      // },
      // {
      //   _name: "CSidebarNavDivider",
      //   _class: "m-2"
      // },
      // {
      //   _name: "CSidebarNavDropdown",
      //   name: "Pages",
      //   route: "/pages",
      //   icon: "cil-star",
      //   items: [
      //     {
      //       name: "Login",
      //       to: "/pages/login",
      //       icon: "cil-star"
      //     },
      //     {
      //       name: "Register",
      //       to: "/pages/register",
      //       icon: "cil-star"
      //     },
      //     {
      //       name: "Error 404",
      //       to: "/pages/404",
      //       icon: "cil-star"
      //     },
      //     {
      //       name: "Error 500",
      //       to: "/pages/500",
      //       icon: "cil-star"
      //     }
      //   ]
      // }
    ]
  }
];
